import { parseMoneyInput } from '../../lib/formatters'
import { formatMoneyBlurValue, moneyDraftFromDisplay } from '../../lib/moneyInputCore'

export function fieldAmount(raw) {
  const n = parseMoneyInput(raw)
  return Number.isFinite(n) ? n : 0
}

/** Merge in-progress drafts before save (Enter on last field does not blur first). */
export function mergeLiveDraftsIntoValues(values, liveDrafts) {
  const merged = { ...values }
  for (const key of Object.keys(merged)) {
    const draft = liveDrafts[key]
    if (draft != null && draft !== '') {
      merged[key] = formatMoneyBlurValue(draft)
    }
  }
  return merged
}

export function amountsFromMergedValues(merged) {
  return {
    payroll: fieldAmount(merged.payroll),
    subs: fieldAmount(merged.subs),
    materials: fieldAmount(merged.materials),
    other: fieldAmount(merged.other),
  }
}

export function totalFromValuesAndDrafts(values, liveDrafts) {
  const merged = mergeLiveDraftsIntoValues(values, liveDrafts)
  return Object.values(merged).reduce((sum, v) => sum + fieldAmount(v), 0)
}

export function draftOrDisplayValue(values, key, draft) {
  const raw = draft != null && draft !== '' ? draft : moneyDraftFromDisplay(values[key])
  return parseMoneyInput(raw)
}
